import React from "react";
import type { Author } from "../AuthorNames";
import Authors from "../Authors";
import Img from "../Img";

interface Props {
  title: string;
  authors: Author[];
  date: string;
  backgroundImage?: any;
}

const BlogDetailHeader = ({ title, authors, date, backgroundImage }: Props) => {
  return (
    <header
      className="relative z-10 w-full bg-black dark:bg-black"
      aria-labelledby="header-title"
    >
      <div className="container relative pt-80 md:pt-0">
        <div className="relative z-20 flex w-full items-center py-12 md:min-h-100 md:w-2/3">
          <div className="space-y-6">
            <h1 id="header-title" className="text-4xl md:text-5xl">
              {title}
            </h1>
            <div className="flex items-center">
              <Authors authors={authors} publishDate={date} />
            </div>
          </div>
        </div>
        <div className="absolute inset-x-0 top-0 z-10 w-full md:hidden">
          <Img
            className="mask-y h-80 w-full object-cover"
            image={backgroundImage}
          />
        </div>
        <div className="absolute inset-y-0 right-0 z-10 hidden w-2/3 md:block 2xl:mr-12">
          <Img
            className="mask-x h-full w-full object-cover"
            image={backgroundImage}
          />
        </div>
      </div>
    </header>
  );
};

export default BlogDetailHeader;
